'use strict';

$(document).ready(function () {
    const isCartPage = $('.cart-page').length > 0;
    const isCheckoutPage = $('#checkout-main').length > 0;
    const isReducedFooterActive = $('.experience-commerce_assets-reducedFooterWrapper').length > 0;

    if (!isCartPage && !isCheckoutPage) {
        sessionStorage.setItem('previousPage', window.location.href);
    }

    if (isCartPage) {
        sessionStorage.setItem('cartUrl', window.location.href);
    }

    if (isReducedFooterActive) {
        $('body').addClass('reduced-footer-active');
    }

    $('.reduced-header-component .back-arrow-wrapper').on('click', function (e) {
        e.preventDefault();

        if (isCheckoutPage) {
            let cartUrl = sessionStorage.getItem('cartUrl');
            window.location.href = cartUrl;
        } else {
            let storedPreviousPage = sessionStorage.getItem('previousPage');

            if (storedPreviousPage) {
                window.location.href = storedPreviousPage;
            } else {
                window.history.back();
            }
        }
    });
});
